import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { sortByUpdated } from "@/utils/comic";
import ComicCard from "@/components/comic/ComicCard";
import SkeletonCard from "@/components/comic/SkeletonCard";

export default function LatestUpdates() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 700);
    return () => clearTimeout(timer);
  }, []);

  const list = sortByUpdated(comics).slice(0, 8);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新更新</h2>
            <p className="mt-2 text-sm text-foreground-600">追踪最近更新章节的双女主韩漫</p>
          </div>
          <Link
            to="/category?sort=updated"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看更多更新 <i className="ri-arrow-right-s-line text-lg" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : list.length === 0 ? (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center text-sm text-foreground-500">
            暂无推荐内容
          </p>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4" data-product-shop>
            {list.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}